import Vuetify from 'vuetify/lib'

export default new Vuetify({
  breakpoint: {
    thresholds: {
      // xs: 340,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
    scrollBarWidth: 24,
  },
})
